import { handleActions } from "redux-actions";
import { MERCHANT } from "constants/action-types";
import { IQuery, IMutate, RequestStatus } from "constants/crud";
import { FetchSchemaAction, FetchedSchemaAction, MutateSchemaAction } from "actions/merchant/merchant-schema";
import { ISchema } from "constants/merchant";

export interface IState extends IQuery<ISchema>, IMutate<ISchema> {}

const initialState: IState = {
    queryError: undefined,
    queryStatus: RequestStatus.Active,
    mutateStatus: RequestStatus.Idle,
    mutateError: undefined,
    result: undefined,
};

export const merchantSchema = handleActions<IState, any>(
    {
        [MERCHANT.SCHEMA.FETCH]: (state: IState, _action: FetchSchemaAction): IState => {
            return {
                ...state,
                ...initialState,
            };
        },
        [MERCHANT.SCHEMA.FETCHED]: (state: IState, action: FetchedSchemaAction): IState => {
            return {
                ...state,
                queryStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                queryError: action.payload instanceof Error ? action.payload : undefined,
                result: action.payload instanceof Error ? undefined : action.payload,
            };
        },
        [MERCHANT.SCHEMA.MUTATE]: (state: IState, _action: MutateSchemaAction): IState => {
            return {
                ...state,
                mutateStatus: RequestStatus.Active,
                mutateError: undefined,
            };
        },
        [MERCHANT.SCHEMA.MUTATED]: (state: IState, action: FetchedSchemaAction): IState => {
            return {
                ...state,
                mutateError: action.payload instanceof Error ? action.payload : undefined,
                mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                result: action.payload instanceof Error ? undefined : action.payload,
            };
        },
    } as any,
    initialState
);
